<template>
    <div class="submission__gallery">

        <div class="submission__gallery__selects">

            <div class="grid three">

                <div class="submission__gallery__select">

                    <h6>
                        {{printString('select_year')}}
                    </h6>

                    <label class="vh" for="yearSelector">{{ printString('all_years') }}</label>
                    <select v-model="selectedYears" id="yearSelector" multiple="multiple">
                        <option v-for="year in years" :key="year.slug" :value="year.slug">{{ year.name }}</option>
                    </select>

                </div>

                <div class="submission__gallery__select">

                    <h6>
                        {{printString('select_language')}}
                    </h6>

                    <label class="vh" for="languageSelector">{{ printString(  'all_languages' ) }}</label>
                    <select v-model="selectedLanguages" id="languageSelector" multiple="multiple">
                        <option v-for="language in languages" :key="language.slug" :value="language.slug">{{ language.name }}</option>
                    </select>

                </div>

                <div class="submission__gallery__select">

                    <h6>
                        {{printString('select_location')}}
                    </h6>

                    <label class="vh" for="locationSelector">{{ printString(  'all_locations' ) }}</label>
                    <select v-model="selectedLocations" id="locationSelector" multiple="multiple">
                        <option v-for="location in locations" :key="location.slug" :value="location.slug">{{ location.name }}</option>
                    </select>

                </div>

            </div>

        </div>

        <div class="" v-if="loading">
            <div class="events__loading">
                <h5>
                    {{ printString(  'loading_events' ) }}
                </h5>
            </div>
        </div>

        <div v-else>

            <div class="">

                <div class="events__loading" v-if="filteredSubmissions.length == 0">
                    <h5>
                        {{ printString(  'no_current_selection' ) }}
                    </h5>
                </div>

                <ul class="grid three">
                    <template v-for="(submission, index) in submissionsLoaded" :key="index">
                        <li v-if="submission.my_canada_years && submission.my_canada_languages && submission.my_canada_locations">

                            <a class="general-block" :href="submission.link" target="_self">


                                <figure v-if="submission.submission_thumbnail" v-html="submission.submission_thumbnail">
                                </figure>

                                <div class="general-block__content">

                                    <h6 class="general-block__year">
                                        {{submission.my_canada_years[0].name}}
                                    </h6>

                                    <h4 class="general-block__title" v-html="submission.title.rendered">
                                    </h4>

                                    <div class="general-block__info">
                                        <span v-html="ico_location"></span>
                                        <p>{{submission.my_canada_locations[0].name}}</p>
                                    </div>

                                    <div class="general-block__info">
                                        <span v-html="ico_language"></span>
                                        <p>{{submission.my_canada_languages[0].name}}</p>
                                    </div>

                                </div>

                            </a>
                        </li>
                    </template>
                </ul>

                <button class="general-button white-background generic-medium"
                        @click="loadMore"
                        @keydown="handleKeyDown"
                        v-if="filteredSubmissions.length > paginationLength ">
                        <span v-html="ico_plus"></span>

                    {{ printString('load_more') }}

                </button>
            </div>
        </div>

    </div>
</template>

<script>
import axios from 'axios';
import { reactive } from 'vue';
import 'select2/dist/js/select2.full.js'
// import ProgramItem from './ProgramItem.vue';

export default {
    data() {
      return {
        _submissions        : window.php_data['submissions'],
        rest_url            : window.php_data['rest_url'],
        lang                : window.php_data['lang'],
        submissions         : [],
        years               : [],
        languages           : [],
        locations           : [],
        selectedYears       : [],
        selectedLanguages   : [],
        selectedLocations   : [],
        loading             : true, // add loading state
        paginationLength    : 12,
        ico_plus            : window.ico_plus,
        ico_location        : window.ico_location,
        ico_language        : window.ico_language,
      };
    },
    computed: {
        filteredSubmissions() {
            return this.submissions.filter(submission => {

                var matchesYears = false;
                if(submission.my_canada_years){
                    matchesYears =
                        this.selectedYears.length === 0 ||
                        submission.my_canada_years.some(year => this.selectedYears.includes(year.slug));
                }

                var matchesLanguages = false;
                if(submission.my_canada_languages){
                    matchesLanguages =
                        this.selectedLanguages.length === 0 ||
                        submission.my_canada_languages.some(language => this.selectedLanguages.includes(language.slug));
                }

                var matchesLocations = false;
                if(submission.my_canada_locations){
                    matchesLocations =
                        this.selectedLocations.length === 0 ||
                        submission.my_canada_locations.some(location => this.selectedLocations.includes(location.slug));
                }

                // Check if the submission matches at least one selected criteria
                return matchesYears && matchesLanguages && matchesLocations;
            });
        },
        submissionsLoaded() {
            return this.filteredSubmissions.slice(0, this.paginationLength);
        },
    },
    mounted() {

      axios.get(this.rest_url+'/wp-json/wp/v2/my-canada-submission?per_page=100&lang=' + window.php_data['lang'])
        .then(response => {

            this.submissions = response.data;

            const yearSlugs = [];
            this.submissions.forEach(submission => {
                if(submission.my_canada_years && submission.my_canada_languages && submission.my_canada_locations){
                    submission.my_canada_years.forEach(year => {
                        if (!yearSlugs.some(item => item.slug === year.slug)) {
                            yearSlugs.push({ slug: year.slug, name: year.name });
                        }
                    });
                }
            });

            // Sort the yearSlugs array based on the 'name' (year) in descending order
            yearSlugs.sort((a, b) => parseInt(b.name) - parseInt(a.name));

            // Assign sorted yearSlugs to this.years
            this.years = yearSlugs;

            const languageSlugs = [];
            this.submissions.forEach(submission => {
                if(submission.my_canada_years && submission.my_canada_languages && submission.my_canada_locations){
                    submission.my_canada_languages.forEach(language => {
                        if (!languageSlugs.includes(language.slug)) {
                            languageSlugs.push(language.slug);
                            this.languages.push(language);
                        }
                    });
                }
            });

            const locationSlugs = [];
            this.submissions.forEach(submission => {
                if(submission.my_canada_years && submission.my_canada_languages && submission.my_canada_locations){
                    submission.my_canada_locations.forEach(location => {
                        if (!locationSlugs.includes(location.slug)) {
                            locationSlugs.push(location.slug);
                            this.locations.push(location);
                        }
                    });
                }
            });

            // Sort the submissions by year
            this.sortSubmissionsByYear();

            this.loading = false; // set loading state to false

        })
        .catch(error => {
          console.log(error);
        });

        let vm = this;


        //===========================YEARS SELECTOR==============================


        jQuery('#yearSelector').select2({
            width: '100%',
            templateSelection: function(data){
                let selectedOptions = jQuery( '#yearSelector' ).select2('data')

                let output = '(' + selectedOptions.length + ') '

                selectedOptions.forEach( function( item ) {
                    output += item.text

                    if( selectedOptions.length > 1 )
                        output += ', '
                })

                if( selectedOptions.length > 1 || output.length > 20 )
                    output = output.substring(0, 20) + '...'

                return '<span tabindex="0">'+output+'</span>'

            },
            allowClear: true,
            placeholder: this.printString('all_years'),
            escapeMarkup: function(m) {
                return m
            },
        }).on('change', function () {
            const selectedYears = jQuery(this).val(); // Get the selected values as an array
            vm.selectedYears = selectedYears; // Update the selectedYears array
        })

        // Add the readonly attribute to the select2-search__field input
        const searchField1 = jQuery('#yearSelector').next().find('.select2-search__field');
        searchField1.attr('readonly', 'readonly');




        ///in caz ca apare task cu labels la select, NU E POSIBIL, E BAGAT DRECU IN EL

        // Add a label for the specific select2 element with ID 'secondYearsLabel'
        // const select2Container = jQuery('.select2[data-select2-id="3"]');
        // const theRealSelect2 = jQuery(select2Container[0].children[0].children[0])
        // theRealSelect2.attr('id', 'secondYearLabel');
        // theRealSelect2.before('<label class="vh" for="secondYearLabel">All Years</label>');


        //============================LANGUAGE SELECTOR=============================


        jQuery('#languageSelector').select2({
            width: '100%',
            templateSelection: function(data){
                let selectedOptions = jQuery( '#languageSelector' ).select2('data')

                let output = '(' + selectedOptions.length + ') '

                selectedOptions.forEach( function( item ) {
                    output += item.text

                    if( selectedOptions.length > 1 )
                        output += ', '
                })

                if( selectedOptions.length > 1 || output.length > 20 )
                    output = output.substring(0, 20) + '...'

                return '<span tabindex="0">'+output+'</span>'

            },
            allowClear: true,
            placeholder: this.printString('all_languages'),
            escapeMarkup: function(m) {
                return m
            },
        }).on('change', function () {
            const selectedLanguages = jQuery(this).val(); // Get the selected values as an array
            // console.log('Selected Languages:', selectedLanguages);
            vm.selectedLanguages = selectedLanguages; // Update the selectedYears arra
        })

        // Add the readonly attribute to the select2-search__field input
        const searchField2 = jQuery('#languageSelector').next().find('.select2-search__field');
        searchField2.attr('readonly', 'readonly');


        //============================LOCATION SELECTOR=============================


        jQuery('#locationSelector').select2({
            width: '100%',
            templateSelection: function(data){
                let selectedOptions = jQuery( '#locationSelector' ).select2('data')

                let output = '(' + selectedOptions.length + ') '

                selectedOptions.forEach( function( item ) {
                    output += item.text

                    if( selectedOptions.length > 1 )
                        output += ', '
                })

                if( selectedOptions.length > 1 || output.length > 20 )
                    output = output.substring(0, 20) + '...'

                return '<span tabindex="0">'+output+'</span>'

            },
            allowClear: true,
            placeholder: this.printString('all_locations'),
            escapeMarkup: function(m) {
                return m
            },
        }).on('change', function () {
            const selectedLocations = jQuery(this).val(); // Get the selected values as an array
            // console.log('Selected Locations:', selectedLocations);
            vm.selectedLocations = selectedLocations; // Update the selectedYears arra
        })

        // Add the readonly attribute to the select2-search__field input
        const searchField3 = jQuery('#locationSelector').next().find('.select2-search__field');
        searchField3.attr('readonly', 'readonly');


        //====================================================================


    },
    methods: {
        printString( string ){
            return window.translations[string]
        },
        loadMore() {
            if (this.paginationLength > this.filteredSubmissions.length)
                return;
            this.paginationLength = this.paginationLength + 3;
        },
        handleKeyDown(event) {
            if (event.keyCode === 13) {
              // Check if the key code is 13 (Enter) and isLoadingMore is false
                this.loadMore();
                event.preventDefault(); // Prevent the default Enter key behavior
            }
        },
        sortSubmissionsByYear() {
            this.submissions.sort((a, b) => {
                // Compare the years of the first items in the 'my_canada_years' array

                if(a.my_canada_years && b.my_canada_years){

                    const yearA = a.my_canada_years[0].name;
                    const yearB = b.my_canada_years[0].name;

                    // Convert year strings to numbers for proper sorting
                    const yearANumber = parseInt(yearA);
                    const yearBNumber = parseInt(yearB);

                    // Use the numeric comparison to sort by year
                    return yearBNumber - yearANumber;

                }
            });
        },
    }
};
</script>
